// import { useEffect, useMemo, useState } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { Button, Box, Grid, MenuItem, TextField, Tooltip, IconButton } from "@mui/material";
// import AccessTimeIcon from "@mui/icons-material/AccessTime";
// import RuleIcon from "@mui/icons-material/Rule";
// import SummarizeIcon from "@mui/icons-material/Summarize";
// import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutlined";
// import PaidIcon from "@mui/icons-material/Paid";
// import { EditIcon } from "lucide-react";
// import { toast } from "react-toastify";
// import TabbedPage from "../../../components/TabbedPage/TabbedPage";
// import DataTable from "../../../components/DataTable/DataTable";
// import StatusChip from "../../../components/StatusChip/StatusChip";
// import AddOvertimeDialog from "../../../components/PayRoll/AddOvertimeDialog";
// import OvertimeRateSetup from "../../../components/PayRoll/OvertimeRateSetup";
// import usePayrollEntity from "../../../utils/usePayrollEntity";
// import { fmtRs } from "../../../utils/payrollFormat";
// import { getEmployeeList } from "../../../action/Employee";
// import { mapOvertimeRow, savePayrollEntity } from "../../../action/Payroll";
// import payRollService from "../../../services/PayrollService";
// import { getLoggedInServiceNo } from "../../../utils/masterDataUtils";

// const withEmployeeInfo = (rows, employeeById) =>
//   rows.map((row) => {
//     const emp = employeeById[row.employeeId];
//     return {
//       ...row,
//       name: row.name || emp?.HED_REPORT_NAME || "Unknown",
//       empNo: row.empNo || emp?.HED_SERVICE_NO || "-",
//     };
//   });

// const getErrorMessage = (error) =>
//   (error.response &&
//     error.response.data &&
//     (error.response.data.Message || error.response.data.message)) ||
//   (error.message === "Network Error"
//     ? "Couldn't reach the server. Check the connection and try again."
//     : error.message) ||
//   error.toString();

// const PRIMARY = "#1B5C20";

// const OvertimeEntryTab = () => {
//   const dispatch = useDispatch();

//   const [open, setOpen] = useState(false);
//   const [editingRow, setEditingRow] = useState(null);

//   const [employeeFilter, setEmployeeFilter] = useState("");
//   const [filteredRows, setFilteredRows] = useState(null);
//   const [filterLoading, setFilterLoading] = useState(false);

//   const employees = useSelector((state) => state.employee.list);
//   const { list, loading, save, saving } = usePayrollEntity("overtimeEntry");
//   const { list: periods } = usePayrollEntity("payrollPeriods");

//   const employeeById = useMemo(() => {
//     const map = {};
//     employees.forEach((emp) => {
//       map[emp.HED_EMPLOYEE_ID] = emp;
//     });
//     return map;
//   }, [employees]);

//   useEffect(() => {
//     dispatch(getEmployeeList());
//   }, [dispatch]);

//   useEffect(() => {
//     if (!employeeFilter) {
//       setFilteredRows(null);
//       return;
//     }

//     let cancelled = false;
//     setFilterLoading(true);

//     payRollService
//       .GetOvertimeByEmployee(employeeFilter)
//       .then((response) => {
//         if (cancelled) return;
//         const raw = response.data.ResultSet || response.data.resultSet || [];
//         setFilteredRows(raw.map(mapOvertimeRow));
//       })
//       .catch(() => {
//         if (!cancelled) setFilteredRows([]);
//       })
//       .finally(() => {
//         if (!cancelled) setFilterLoading(false);
//       });

//     return () => {
//       cancelled = true;
//     };
//   }, [employeeFilter]);

//   const rows = withEmployeeInfo(filteredRows === null ? list : filteredRows, employeeById);

//   const handleSave = async (form) => {
//     try {
//       // await save(form, !!editingRow);

//       await dispatch(
//         savePayrollEntity(
//           "overtimeEntry",
//           form,
//           !!editingRow
//         )
//       )

//       toast.success(
//         editingRow ? "Overtime entry updated." : "Overtime entry added.",
//         { autoClose: 2000 }
//       );
//       setOpen(false);
//       setEditingRow(null);
//     } catch (error) {
//       toast.error(getErrorMessage(error), { autoClose: 4000 });
//     }
//   };

//   const handleEdit = async (row) => {
//     try {
//       const response = await payRollService.GetOvertimeById(row.id);
//       const fresh = (response.data.ResultSet || response.data.resultSet || [])[0];
//       setEditingRow(fresh ? { ...row, ...fresh } : row);
//     } catch {
//       setEditingRow(row);
//     }
//     setOpen(true);
//   };

//   return (
//     <>
//       <Box sx={{ mb: 2 }}>
//         <Grid container spacing={2}>
//           <Grid item xs={12} md={5}>
//             <div className="w-full">
//               <label
//                 htmlFor="employee-filter"
//                 className="mb-1 block text-sm font-medium text-gray-700"
//               >
//                 Filter by Employee
//               </label>

//               <select
//                 id="employee-filter"
//                 value={employeeFilter}
//                 onChange={(e) => setEmployeeFilter(e.target.value)}
//                 className="
//                   block w-full rounded-md border border-gray-300
//                   bg-white px-3 py-2 text-sm text-gray-900
//                   shadow-sm outline-none
//                   transition
//                   hover:border-gray-400
//                   focus:border-green-700
//                   focus:ring-2 focus:ring-green-700/20
//                 "
//               >
//                 <option value="">All Employees</option>

//                 {employees.map((emp) => (
//                   <option
//                     key={emp.HED_EMPLOYEE_ID}
//                     value={emp.HED_EMPLOYEE_ID}
//                   >
//                     {emp.HED_REPORT_NAME || "-"} ({emp.HED_SERVICE_NO})
//                   </option>
//                 ))}
//               </select>
//             </div>
//           </Grid>
//         </Grid>
//       </Box>

//       <DataTable
//         loading={loading || filterLoading}
//         rows={rows}
//         searchKeys={["empNo", "name"]}
//         searchPlaceholder="Search overtime entries..."
//         onAdd={{
//           label: "New Entry",
//           onClick: () => {
//             setEditingRow(null);
//             setOpen(true);
//           },
//         }}
//         columns={[
//           { key: "name", label: "Employee", render: (r) => `${r.name} (${r.empNo})` },
//           { key: "date", label: "Date" },
//           { key: "hours", label: "Hours", align: "right" },
//           { key: "rate", label: "Rate", align: "right", render: (r) => fmtRs(r.rate) },
//           { key: "amount", label: "Amount", align: "right", render: (r) => fmtRs(r.amount) },
//           { key: "status", label: "Status", render: (r) => <StatusChip status={r.status} /> },
//           {
//             key: "actions",
//             label: "Actions",
//             align: "center",
//             render: (r) => (
//               <Tooltip title="Edit Overtime">
//                 <IconButton size="small" color="primary" onClick={() => handleEdit(r)}>
//                   <EditIcon fontSize="small" />
//                 </IconButton>
//               </Tooltip>
//             ),
//           },
//         ]}
//       />

//       <AddOvertimeDialog
//         open={open}
//         onClose={() => {
//           setOpen(false);
//           setEditingRow(null);
//         }}
//         onSave={handleSave}
//         employees={employees}
//         payrollPeriods={periods}
//         loading={saving}
//         initialData={editingRow}
//       />
//     </>
//   );
// };

// const OvertimeApprovalTab = () => {
//   const dispatch = useDispatch();

//   const employees = useSelector((state) => state.employee.list);

//   const { list, loading, save } = usePayrollEntity("overtimeEntry");
//   // const pending = list.filter((row) => !row.isApproved);

//   useEffect(() => {
//     if (!employees?.length) {
//       dispatch(getEmployeeList());
//     }
//   }, [dispatch, employees?.length]);

//   const employeeById = useMemo(() => {
//     const map = {};

//     employees.forEach((emp) => {
//       map[String(emp.HED_EMPLOYEE_ID)] = emp;
//     });

//     return map;
//   }, [employees]);

//   const pending = withEmployeeInfo(
//     list.filter((row) => !row.isApproved),
//     employeeById
//   );

//   const approve = (row) => {
//     save({ ...row, isApproved: true, approvedBy: getLoggedInServiceNo() }, true)
//       .then(() => toast.success(`Overtime for ${row.name} approved.`, { autoClose: 2000 }))
//       .catch((error) =>
//         toast.error(error.message || "Couldn't approve this entry.", { autoClose: 3000 })
//       );
//   };

//   return (
//     <DataTable
//       loading={loading}
//       rows={pending}
//       searchKeys={["empNo", "name"]}
//       searchPlaceholder="Search pending overtime..."
//       columns={[
//         { key: "name", label: "Employee", render: (r) => `${r.name} (${r.empNo})` },
//         { key: "date", label: "Date" },
//         { key: "hours", label: "Hours", align: "right" },
//         { key: "amount", label: "Amount", align: "right", render: (r) => fmtRs(r.amount) },
//         { key: "status", label: "Status", render: (r) => <StatusChip status={r.status} /> },
//         {
//           key: "actions",
//           label: "Actions",
//           align: "center",
//           render: (r) => (
//             <Button
//               size="small"
//               startIcon={<CheckCircleOutlineIcon />}
//               onClick={() => approve(r)}
//               sx={{ textTransform: "none", color: PRIMARY }}
//             >
//               Approve
//             </Button>
//           ),
//         },
//       ]}
//     />
//   );
// };

// const OvertimeSummaryTab = () => {
//   const { list } = usePayrollEntity("overtimeEntry");

//   const byPeriod = {};
//   list.forEach((row) => {
//     const key = row.date ? row.date.slice(0, 7) : "Unknown";
//     if (!byPeriod[key]) {
//       byPeriod[key] = { id: key, month: key, totalHours: 0, totalAmount: 0 };
//     }
//     byPeriod[key].totalHours += Number(row.hours) || 0;
//     byPeriod[key].totalAmount += Number(row.amount) || 0;
//   });

//   return (
//     <DataTable
//       loading={false}
//       rows={Object.values(byPeriod)}
//       searchKeys={["month"]}
//       searchPlaceholder="Search periods..."
//       columns={[
//         { key: "month", label: "Period" },
//         { key: "totalHours", label: "Total Hours", align: "right" },
//         { key: "totalAmount", label: "Total Amount", align: "right", render: (r) => fmtRs(r.totalAmount) },
//       ]}
//     />
//   );
// };

// const Overtime = () => {
//   const tabs = [
//     { key: "entry", label: "Overtime Entry", icon: <AccessTimeIcon />, content: <OvertimeEntryTab /> },
//     { key: "approval", label: "Overtime Approval", icon: <RuleIcon />, content: <OvertimeApprovalTab /> },
//     { key: "summary", label: "Overtime Summary", icon: <SummarizeIcon />, content: <OvertimeSummaryTab /> },
//     { key: "rate", label: "OT Rate Setup", icon: <PaidIcon />, content: <OvertimeRateSetup /> },
//   ];

//   return (
//     <TabbedPage
//       icon={<AccessTimeIcon sx={{ color: PRIMARY, fontSize: 28 }} />}
//       title="Overtime"
//       subtitle="Record, approve and summarize overtime hours before payroll processing."
//       tabs={tabs}
//     />
//   );
// };

// export default Overtime;




import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import RuleIcon from "@mui/icons-material/Rule";
import SummarizeIcon from "@mui/icons-material/Summarize";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutlined";
import PaidIcon from "@mui/icons-material/Paid";
import { EditIcon } from "lucide-react";
import { toast } from "react-toastify";
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import Tabs from "../../../components/Tabs/Tabs";
import Table, { StatusPill } from "../../../components/Table/Table";
import AddOvertimeDialog from "../../../components/PayRoll/AddOvertimeDialog";
import OvertimeRateSetup from "../../../components/PayRoll/OvertimeRateSetup";
import usePayrollEntity from "../../../utils/usePayrollEntity";
import { fmtRs } from "../../../utils/payrollFormat";
import { fetchAllEmployees } from "../../../store/slices/employeeSlice";
import { mapOvertimeRow, savePayrollEntity } from "../../../store/slices/payrollSlice";
import payRollService from "../../../services/PayrollService";
import { getLoggedInServiceNo } from "../../../utils/masterDataUtils";

const withEmployeeInfo = (rows, employeeById) =>
  rows.map((row) => {
    const emp = employeeById[row.employeeId];
    return {
      ...row,
      name: row.name || emp?.HED_REPORT_NAME || "Unknown",
      empNo: row.empNo || emp?.HED_SERVICE_NO || "-",
    };
  });

const getErrorMessage = (error) =>
  (error.response &&
    error.response.data &&
    (error.response.data.Message || error.response.data.message)) ||
  (error.message === "Network Error"
    ? "Couldn't reach the server. Check the connection and try again."
    : error.message) ||
  error.toString();

const PRIMARY = "#1B5C20";

const OvertimeEntryTab = () => {
  const dispatch = useDispatch();

  const [open, setOpen] = useState(false);
  const [editingRow, setEditingRow] = useState(null);

  const [employeeFilter, setEmployeeFilter] = useState("");
  const [filteredRows, setFilteredRows] = useState(null);
  const [filterLoading, setFilterLoading] = useState(false);

  const employees = useSelector((state) => state.employees.employees);
  const { list, loading, save, saving } = usePayrollEntity("overtimeEntry");
  const { list: periods } = usePayrollEntity("payrollPeriods");

  const employeeById = useMemo(() => {
    const map = {};
    employees.forEach((emp) => {
      map[emp.HED_EMPLOYEE_ID] = emp;
    });
    return map;
  }, [employees]);

  useEffect(() => {
    dispatch(fetchAllEmployees());
  }, [dispatch]);

  useEffect(() => {
    if (!employeeFilter) {
      setFilteredRows(null);
      return;
    }

    let cancelled = false;
    setFilterLoading(true);

    payRollService
      .GetOvertimeByEmployee(employeeFilter)
      .then((response) => {
        if (cancelled) return;
        const raw = response.data.ResultSet || response.data.resultSet || [];
        setFilteredRows(raw.map(mapOvertimeRow));
      })
      .catch(() => {
        if (!cancelled) setFilteredRows([]);
      })
      .finally(() => {
        if (!cancelled) setFilterLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [employeeFilter]);

  const rows = withEmployeeInfo(filteredRows === null ? list : filteredRows, employeeById);

  const handleSave = async (form) => {
    try {
      // await save(form, !!editingRow);

      await dispatch(
        savePayrollEntity(
          "overtimeEntry",
          form,
          !!editingRow
        )
      )

      toast.success(
        editingRow ? "Overtime entry updated." : "Overtime entry added.",
        { autoClose: 2000 }
      );
      setOpen(false);
      setEditingRow(null);
    } catch (error) {
      toast.error(getErrorMessage(error), { autoClose: 4000 });
    }
  };

  const handleEdit = async (row) => {
    try {
      const response = await payRollService.GetOvertimeById(row.id);
      const fresh = (response.data.ResultSet || response.data.resultSet || [])[0];
      setEditingRow(fresh ? { ...row, ...fresh } : row);
    } catch {
      setEditingRow(row);
    }
    setOpen(true);
  };

  return (
    <>
      <div className="mb-4 flex flex-wrap items-end gap-4">
        <div className="w-full max-w-sm">
          <label htmlFor="employee-filter" className="mb-1 block text-xs font-semibold uppercase tracking-wide text-gray-500">
            Filter by Employee
          </label>
          <select
            id="employee-filter"
            value={employeeFilter}
            onChange={(e) => setEmployeeFilter(e.target.value)}
            className="w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm text-gray-900 shadow-sm outline-none transition focus:border-primary-600 focus:ring-2 focus:ring-primary-100"
          >
            <option value="">All Employees</option>
            {employees.map((emp) => (
              <option key={emp.HED_EMPLOYEE_ID} value={emp.HED_EMPLOYEE_ID}>
                {emp.HED_REPORT_NAME || "-"} ({emp.HED_SERVICE_NO})
              </option>
            ))}
          </select>
        </div>
      </div>

      <Table
        loading={loading || filterLoading}
        rows={rows}
        rowKey="id"
        title="Overtime Entries"
        search
        searchKeys={["empNo", "name"]}
        searchPlaceholder="Search overtime entries..."
        emptyMessage="No overtime entries found"
        pageSize={9}
        onAdd={{
          label: "New Entry",
          onClick: () => {
            setEditingRow(null);
            setOpen(true);
          },
        }}
        columns={[
          { key: "name", label: "Employee", className: "font-semibold text-gray-900", render: (r) => `${r.name} (${r.empNo})` },
          { key: "date", label: "Date", className: "text-gray-600" },
          { key: "hours", label: "Hours", align: "right", className: "text-gray-600" },
          { key: "rate", label: "Rate", align: "right", className: "text-gray-600", render: (r) => fmtRs(r.rate) },
          { key: "amount", label: "Amount", align: "right", className: "font-semibold text-gray-900", render: (r) => fmtRs(r.amount) },
          { key: "status", label: "Status", align: "center", render: (r) => <StatusPill label={r.status} /> },
          {
            key: "actions",
            label: "Actions",
            align: "center",
            render: (r) =>
              r.status === "Pending" ? (
                <button type="button" onClick={() => handleEdit(r)} className="inline-flex h-8 w-8 items-center justify-center rounded-md text-gray-500 transition-colors hover:bg-primary-50 hover:text-primary-700" title="Edit Overtime">
                  <EditIcon size={16} />
                </button>
              ) : null,
          },
        ]}
      />

      <AddOvertimeDialog
        open={open}
        onClose={() => {
          setOpen(false);
          setEditingRow(null);
        }}
        onSave={handleSave}
        employees={employees}
        payrollPeriods={periods}
        loading={saving}
        initialData={editingRow}
      />
    </>
  );
};

const OvertimeApprovalTab = () => {
  const dispatch = useDispatch();

  const employees = useSelector((state) => state.employees.employees);

  const { list, loading } = usePayrollEntity("overtimeEntry");
  // const pending = list.filter((row) => !row.isApproved);

  useEffect(() => {
    if (!employees?.length) {
      dispatch(fetchAllEmployees());
    }
  }, [dispatch, employees?.length]);

  const employeeById = useMemo(() => {
    const map = {};

    employees.forEach((emp) => {
      map[String(emp.HED_EMPLOYEE_ID)] = emp;
    });

    return map;
  }, [employees]);

  const pending = withEmployeeInfo(
    list.filter((row) => !row.isApproved),
    employeeById
  );

  const approve = async (row) => {
    try {
      await dispatch(
        savePayrollEntity(
          "overtimeEntry",
          { ...row, isApproved: true, approvedBy: getLoggedInServiceNo() },
          true
        )
      );
      toast.success(`Overtime for ${row.name} approved.`, { autoClose: 2000 });
    } catch (error) {
      toast.error(error.message || "Couldn't approve this entry.", { autoClose: 3000 });
    }
  };

  return (
    <Table
      loading={loading}
      rows={pending}
      rowKey="id"
      title="Pending Overtime Approvals"
      search
      searchKeys={["empNo", "name"]}
      searchPlaceholder="Search pending overtime..."
      emptyMessage="No pending overtime approvals"
      pageSize={9}
      columns={[
        { key: "name", label: "Employee", className: "font-semibold text-gray-900", render: (r) => `${r.name} (${r.empNo})` },
        { key: "date", label: "Date", className: "text-gray-600" },
        { key: "hours", label: "Hours", align: "right", className: "text-gray-600" },
        { key: "amount", label: "Amount", align: "right", className: "font-semibold text-gray-900", render: (r) => fmtRs(r.amount) },
        { key: "status", label: "Status", align: "center", render: (r) => <StatusPill label={r.status} /> },
        {
          key: "actions",
          label: "Actions",
          align: "center",
          render: (r) => (
            <button
              type="button"
              onClick={() => approve(r)}
              className="inline-flex items-center gap-1.5 rounded-md px-2 py-1.5 text-xs font-semibold text-primary-700 transition-colors hover:bg-primary-50"
            >
              <CheckCircleOutlineIcon sx={{ fontSize: 16 }} />
              Approve
            </button>
          ),
        },
      ]}
    />
  );
};

const OvertimeSummaryTab = () => {
  const { list } = usePayrollEntity("overtimeEntry");

  const byPeriod = {};
  list.forEach((row) => {
    const key = row.date ? row.date.slice(0, 7) : "Unknown";
    if (!byPeriod[key]) {
      byPeriod[key] = { id: key, month: key, totalHours: 0, totalAmount: 0 };
    }
    byPeriod[key].totalHours += Number(row.hours) || 0;
    byPeriod[key].totalAmount += Number(row.amount) || 0;
  });

  return (
    <Table
      loading={false}
      rows={Object.values(byPeriod)}
      rowKey="id"
      title="Overtime Summary"
      search
      searchKeys={["month"]}
      searchPlaceholder="Search periods..."
      emptyMessage="No overtime summary found"
      pageSize={9}
      columns={[
        { key: "month", label: "Period", className: "font-semibold text-gray-900" },
        { key: "totalHours", label: "Total Hours", align: "right", className: "text-gray-600" },
        { key: "totalAmount", label: "Total Amount", align: "right", className: "font-semibold text-gray-900", render: (r) => fmtRs(r.totalAmount) },
      ]}
    />
  );
};

const Overtime = () => {
  const tabs = [
    { key: "entry", label: "Overtime Entry", icon: <AccessTimeIcon />, content: <OvertimeEntryTab /> },
    { key: "approval", label: "Overtime Approval", icon: <RuleIcon />, content: <OvertimeApprovalTab /> },
    // { key: "summary", label: "Overtime Summary", icon: <SummarizeIcon />, content: <OvertimeSummaryTab /> },
    // { key: "rate", label: "OT Rate Setup", icon: <PaidIcon />, content: <OvertimeRateSetup /> },
  ];

  return (
    <div className="space-y-4 p-6">
      <Breadcrumb
        trail={["Payroll", "Overtime"]}
        title="Overtime"
        subtitle="Record, approve and summarize overtime hours before payroll processing."
      />
      <Tabs tabs={tabs} defaultTab="entry" />
    </div>
  );
};

export default Overtime;